import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { withTheme, Theme } from 'styled-components';
import { StyledUncontrolledTooltip } from '../../styled';
import { StyledValue } from './styled';

export type Placement =
  | 'auto'
  | 'auto-start'
  | 'auto-end'
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end';

export interface ITooltipProps {
  backgroundColor?: string;
  placement?: Placement;
  tooltip: string;
  tooltipId: string;
  value?: string;
  hasMaxWidth?: boolean;
  hasMinimalPadding?: boolean;
  theme: Theme;
}

export const Tooltip = ({
  backgroundColor,
  placement,
  tooltip,
  tooltipId,
  value,
  hasMaxWidth = true,
  hasMinimalPadding = false,
}: ITooltipProps): JSX.Element => {
  const isMobile = useMediaQuery({ maxWidth: 400 });
  const defaultPlacement = isMobile ? 'top' : 'right';
  return (
    <>
      <StyledValue>
        <span id={tooltipId}>{value}</span>
      </StyledValue>
      <StyledUncontrolledTooltip
        backgroundColor={backgroundColor}
        placement={placement || defaultPlacement}
        autohide={false}
        target={tooltipId}
        trigger="hover"
        hasMaxWidth={hasMaxWidth}
        hasMinimalPadding={hasMinimalPadding}
      >
        <p>{tooltip}</p>
      </StyledUncontrolledTooltip>
    </>
  );
};

export default withTheme(Tooltip);
